import { parentesco } from '@utils';
import {
  casoUniaoEstavel,
  certidaoGenitor,
  childs,
  commons,
  concessionLetterINSS,
  convivente,
  death,
  others,
  parents,
  seriousIllness,
  specialChild,
  spouses,
  termos,
} from './constants';
import { initialValuesGenerator } from './initialValueGenerator';
import { dynamicRule } from './rules';

const { constants } = parentesco;

// Usado nos forms: saldo cotas,  rcm variavel plano b
export const anexosComObito = () => {
  const rules = {
    anexoCertidaoDeObito: dynamicRule('required'),
    anexoCertidaoCasamentoOuNascimento: dynamicRule('pais'),
    anexoRG: dynamicRule('required'),
    anexoCPF: dynamicRule('required'),
    anexoCertidaoCasamento: dynamicRule('casamento'),
    anexoCertidaoNascimento: dynamicRule('nascimento'),
    anexoLaudoMedico: dynamicRule('laudoMedico'),

    anexoConvivente: dynamicRule('convivente'),
    anexoCasoUniaoEstavel: dynamicRule(),

    anexoCertidaoCasamentoGenitor: dynamicRule('enteado'),
    anexoCartaConcessaoINSS: dynamicRule(),

    anexoTermos: dynamicRule(),
    anexoOutros: dynamicRule(),
  };
  const docs = {
    commons: [...commons, ...death, ...concessionLetterINSS],
    others: [...others],
    [constants.PAI]: parents,
    [constants.MAE]: parents,
    [constants.CONJUGE]: spouses,
    [constants.EX_CONJUGE]: spouses,
    [constants.FILHO]: childs,
    [constants.FILHO_ESPECIAL]: [...childs, ...specialChild],
    [constants.CONVIVENTE]: [...convivente, ...casoUniaoEstavel, ...termos],
    [constants.ENTEADO]: [...childs, ...certidaoGenitor, ...termos],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};

export const commonsDocs = {
  initialValues: {
    anexoRG: '',
    anexoCPF: '',
  },
  rules: {
    anexoRG: dynamicRule('required'),
    anexoCPF: dynamicRule('required'),
  },
  docs: commons,
};

export const commonDocsBeneficiario = {
  initialValues: {
    anexoRG: '',
    anexoCPF: '',
  },
  rules: {
    anexoRG: dynamicRule('beneficiario'),
    anexoCPF: dynamicRule('beneficiario'),
  },
  docs: commons,
};

export const molestiaGraveDocs = {
  initialValues: {
    anexoLaudoSUS: '',
  },
  rules: {
    anexoLaudoSUS: dynamicRule('molestia'),
  },
  docs: {
    molestiaGrave: seriousIllness,
  },
};
